export enum RiskRegisterViewMode {
    ExposureBand = "exposure-band",
    Likelihood = "likelihood",
    HealthRisk = "health-risk",
}
